import firebase from 'firebase/app'
import 'firebase/functions'
import { db } from '@/utils/Firebase'
import { getPayloadBlock, getPayloadBaseRoutine, getPayloadExercise } from '@/utils/Exercises'

export async function generateLibraryItem({ type, prompt, level, duration, equipments, locale = 'es' }) {
    const generate = firebase.app().functions('us-central1').httpsCallable('aiGenerateLibraryItem')
    const result = await generate({ type, prompt, level, duration, equipments, locale })
    return result.data
}

export async function getLibraryUsage() {
    const getUsage = firebase.app().functions('us-central1').httpsCallable('aiGetLibraryUsage')
    const result = await getUsage()
    return result.data
}

function buildConfigFromSets(sets, reps) {
    const setsCount = Number(sets) || 1
    const data = []
    for (let i = 0; i < setsCount; i++) {
        data.push({
            data: [{
                name: 'Repeticiones',
                short_name: 'short_reps',
                value: reps || '',
                icon: 'mdi-repeat',
            }],
        })
    }
    return { sets: data }
}

export function resolveGeneratedExercises(aiExercises = [], catalog = []) {
    return aiExercises.map(ex => {
        const found = catalog.find(c => c.objectID === ex.id) || {}
        return getPayloadExercise({
            id: ex.id,
            objectID: ex.id,
            name: found.name || '',
            commentary: ex.commentary || '',
            config: buildConfigFromSets(ex.sets, ex.reps),
        })
    })
}

export async function saveEditedBlock(coachId, folder, name, block, tags = []) {
    const payload = getPayloadBlock(
        name,
        coachId,
        block,
        { id: folder?.id || null, name: folder?.name || null },
        tags,
    )
    const ref = await db.collection('blocks').add(payload)
    return ref.id
}

export async function saveEditedRoutine(coachId, name, editedBlocks, category, tags = []) {
    const blocks = editedBlocks.map((block, i) => {
        const isCircuit = block.isCircuit || false
        return {
            id: i + 1,
            completed: false,
            duration: 0,
            sets: isCircuit ? block.sets || null : null,
            tabata: isCircuit ? block.tabata || null : null,
            isCircuit,
            type: isCircuit ? block.type || null : null,
            name: block.name || null,
            exercises: block.exercises.map(exercise => getPayloadExercise(exercise)),
        }
    })
    const payload = getPayloadBaseRoutine(name, { coachId, owner: 'user' }, blocks, category || '', null, tags)
    const ref = await db.collection('routines').add(payload)
    return ref.id
}
